/**
 * Serialize an unknown thrown value into a plain, log-friendly object.
 *
 * The host (x2-trade) Datadog child logger only preserves an `Error` when it is
 * passed as the *message* argument; an `Error` passed as metadata is spread and
 * loses its (non-enumerable) `message`/`stack`. Passing `serializeError(err)` in
 * the metadata object keeps a descriptive message string AND the error detail.
 */
export const serializeError = (
  error: unknown
): { name?: string; message: string; stack?: string } =>
  error instanceof Error
    ? { name: error.name, message: error.message, stack: error.stack }
    : { message: String(error) };
